import { render, staticRenderFns } from "./EducationalScheduleTimes.vue?vue&type=template&id=9fb65ab8&"
import script from "./EducationalScheduleTimes.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports